import React from "react";
import { useIntl } from "react-intl";
import { logPosition, RankingChart, RankingBalloonMarker } from "../ranking-widget";
import rankingWidgetMessages from "../ranking-widget/messages.i18n";
import messages from "./messages.i18n";
import { WhiskerBar } from "./WhiskerBar";
import { WhiskerEmptyState } from "./WhiskerEmptyState";
export const WhiskerRangeChart = ({ distribution, yourValue, yourRank, totalCompetitors, }) => {
    const intl = useIntl();
    if (!distribution) {
        return React.createElement(WhiskerEmptyState, null);
    }
    const { min, p25, p50, p75, max } = distribution;
    const q1Pct = logPosition(p25, min, max);
    const medianPct = logPosition(p50, min, max);
    const q3Pct = logPosition(p75, min, max);
    const userPct = logPosition(yourValue, min, max);
    return (React.createElement(RankingChart, { min: min, max: max, minTooltip: intl.formatMessage(messages.tooltipMin, { min: Math.round(min) }), maxTooltip: intl.formatMessage(messages.tooltipMax, { max: Math.round(max) }), balloon: React.createElement(RankingBalloonMarker, { pct: userPct, label: intl.formatMessage(messages.youRankLabel, { rank: yourRank }), tooltipTitle: intl.formatMessage(rankingWidgetMessages.tooltipYou, {
                rank: yourRank,
                total: totalCompetitors,
            }) }), markers: React.createElement(WhiskerBar, { q1Pct: q1Pct, medianPct: medianPct, q3Pct: q3Pct }) }));
};
export default WhiskerRangeChart;
